export enum SavingStatus {
    Saved = "saved",
    Saving = "saving",
    Unsaved = "unsaved",
}